import React, { useEffect, useState } from "react";
import { MdOutlineEnergySavingsLeaf } from "react-icons/md";
import { FaHandHoldingWater } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood } from "react-icons/io5";
import { FaBox } from "react-icons/fa6";
import { IoMan } from "react-icons/io5";
import { FaBoxesPacking } from "react-icons/fa6";
import { FaCircle, FaTimes, FaCheckCircle, FaExclamationCircle, FaInfoCircle } from "react-icons/fa";
import { Line, Pie } from "react-chartjs-2";
import axiosConn from "config/axiosConn.js";
import { MdEventNote, MdHealthAndSafety, MdEdit } from "react-icons/md";
import { useGetHealthyPledgeQuery, useCheckHealthyPledgeQuery, useCheckEkped3EventQuery, useGetSwachhataStatusQuery } from "../../redux/auth/authApi";
import "./Swachhata/Swachhata.css";
import PledgeModal from "./PledgeModal";
import SchoolProgramCards from "./SchoolProgramCards";
import { EKPED3_SCHOOL_ENABLED } from "../../config/campaigns";
import "./PledgeModal.css";
import "./DashboardHeader.css";
import { jwtDecode } from "jwt-decode";

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import Langfield from "../../assets/Json/dashboardJson.json";
import SideBar from "./SideBar";
import Helper from "../../helper/Common_Helper";
import { Link } from "react-router-dom";
import { GrRestroomWomen } from "react-icons/gr";
import { changeLang, selectedVoice } from "../../redux/langSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaBarsStaggered, FaTrash } from "react-icons/fa6";
import { toast } from "react-toastify";
import { encryptPdfForTransport } from "../../utils/fileCrypto";

function AdminDashboard() {
  const { data: myPledge, refetch: refetchMyPledge } = useGetHealthyPledgeQuery();
  const { data: pledgeStatus, refetch: refetchPledgeStatus } = useCheckHealthyPledgeQuery();
  const [showPledgeInfo, setShowPledgeInfo] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);



  const [openSidebar, setOpenSidebar] = useState(false);
  const [langSelected, setLangSelected] = useState("en-IN");
  const translations = Langfield[langSelected];
  const [storeLang, setStoreLang] = useState("en-IN");
  const [countData, setCountData] = useState({});
  const [role, setRole] = useState();
  const [schoolName, setSchoolName] = useState("");
  const [udise_id, setUDISE] = useState("");
  const [teacher_name, setTeacherName] = useState("");
  const [matrixCount, setMatrixCount] = useState({});
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  // Ek Ped 3.0 total — reuses the SAME cached query as the login popup (no extra
  // DB call). Drives the "Saplings Planted" card + the 3.0 certificate button.
  // Not fetched at all while the campaign is switched off for schools.
  const { data: ekped3Data } = useCheckEkped3EventQuery(undefined, { skip: !userData || !EKPED3_SCHOOL_ENABLED });
  const plantation3Trees = ekped3Data?.trees || 0;
  // Swachhata Hi Seva 2026 — the school's SWM report (form). "Fill Form" until
  // it is submitted, then "Update Details" + certificate.
  const { data: swachhataData } = useGetSwachhataStatusQuery(undefined, { skip: !userData });
  const swachhataSurvey = swachhataData?.participation?.survey;
  // E-Waste Collection Drive — status rides on the same Swachhata status call.
  const ewasteSummary = swachhataData?.ewaste;
  const sc6Summary = swachhataData?.sc6;
  const bricsSummary = swachhataData?.brics;
  const ewasteDone = ewasteSummary?.status === "submitted";
  const swachhataDone = swachhataSurvey?.status === "submitted";
  const [showModal, setShowModal] = useState(false);
  const [fileName, setFileName] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  // null = not known yet (loading / request failed) — show nothing rather than
  // telling a school that already uploaded to "please upload".
  const [notificationStatus, setNotificationStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const translate = (key) => {
    if (typeof translations !== "object" || translations === null) {
      return key;
    }
    if (typeof key !== "string") {
      return key;
    }
    return translations[key] || key.replace(/_/g, " ");
  };

  const [lineChartData, setLineChartData] = useState({
    labels: [
      translate("January"),
      translate("February"),
      translate("March"),
      translate("April"),
      translate("May"),
      translate("June"),
      translate("July"),
      translate("August"),
      translate("September"),
      translate("October"),
      translate("November"),
      translate("December"),
    ],
    datasets: [
      {
        label: translate("Digital"),
        borderColor: "#4caf50",
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        label: translate("Physical"),
        borderColor: "#f44336",
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const getNotificationStatus = async (udise_id) => {
    try {
      const response = await axiosConn(
        "get",
        `get-eco-club-notification`
      );
      if (response.data.status === "success") {
        const Data = response.data.result;
        if (Data && Data?.notification_status !== true) {
          setNotificationStatus(false);
          setShowModal(true);
        } else {
          setNotificationStatus(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // getCount();
    if (userData) {
      getNotificationStatus(userData.udise_id);
      setRole(userData.role);
      setUDISE(userData.udise_id);
      setSchoolName(userData.school_name);
      getMatricData(userData?.udise_id);
      setLangSelected(userData.lang);
      setStoreLang(userData.lang);
      if (userData?.teacher_name) {
        setTeacherName(userData.teacher_name);
      }
    }
    // Depend on the stable UDISE, not the userData object reference, so the
    // notification + matrix calls fire once per login instead of on every
    // userData re-render (they were firing 3×).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.udise_id]);

  const getMatricData = async (udise_id) => {
    try {
      // let postData = { udise_id: userData.udise_id };
      const response = await axiosConn("post", `get-matrix-data`);
      if (response.data.status === "success") {
        setMatrixCount(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCount = async () => {
    try {
      // let postData = { udise_id };
      // const response = await axiosConn("post", `dashboard-count`, postData);
      // if (response.data.status === "success") {
      //   setCountData(response?.data?.data);
      //   updateLineChartData(response?.data?.data);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileChange = (e) => {
    try {
      console.log("📁 handleFileChange triggered", { eventType: e.type });

      // CRITICAL: Read files synchronously IMMEDIATELY before any async operations
      const files = Array.from(e.target.files);
      console.log("📁 Files captured synchronously:", {
        count: files.length,
        files: files.map(f => ({ name: f.name, size: f.size, type: f.type }))
      });

      if (files.length === 0) {
        console.warn("⚠️ No files selected");
        return;
      }

      const allowedImageTypes = ["image/png", "image/jpeg", "image/jpg"];
      const allowedPdfType = "application/pdf";
      const allowedTypes = [...allowedImageTypes, allowedPdfType];

      if (files.length > 1) {
        console.warn("⚠️ Too many files selected");
        toast.warning("You can only upload up to 1 file");
        e.target.value = "";
        return;
      }

      const file = files[0];
      console.log("📁 File selected:", { name: file.name, size: file.size, type: file.type });

      if (!allowedTypes.includes(file.type)) {
        console.warn("⚠️ Invalid file type:", file.type);
        toast.warning(
          translate("Only PNG, JPEG, JPG, and PDF files are allowed")
        );
        e.target.value = "";
        return;
      }

      // Set preview and selected file before upload
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
      console.log("✅ Preview and state set, calling uploadFileAsync...");

      // NOW do the async upload
      uploadFileAsync(file, e);
    } catch (error) {
      console.error("❌ Error in file selection:", error);
      toast.error("Error selecting file");
      e.target.value = "";
    }
  };

  const uploadFileAsync = async (file, e) => {
    setIsUploading(true);
    try {
      console.log("⬆️ uploadFileAsync started", { fileName: file.name, fileSize: file.size, fileType: file.type });

      // Proceed with upload
      const formData = new FormData();
      let fileToUpload = file;

      if (file.type === "application/pdf") {
        console.log("🔐 PDF detected - encrypting...");
        const { encryptedFile, metadata } = await encryptPdfForTransport(file);
        console.log("🔐 PDF encrypted", { metadataKeys: Object.keys(metadata) });

        Object.entries(metadata).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append("files", encryptedFile);
        fileToUpload = encryptedFile;
      } else {
        formData.append("files", file);
      }

      console.log("📦 FormData created", {
        entries: Array.from(formData.entries()).map(([key, value]) => ({
          key,
          type: value instanceof File ? `File(${value.name}, ${value.size} bytes)` : typeof value
        }))
      });

      console.log("🌐 Sending API request to upload-collaboration-file...");
      const response = await axiosConn(
        "post",
        "upload-collaboration-file",
        formData
      );

      console.log("📥 API Response:", response.data);

      if (response.data.status === "success") {
        const uploadedFiles = response.data.data;
        console.log("✅ Upload successful:", uploadedFiles);
        setFileName(uploadedFiles);
        toast.success("File uploaded. Now click Submit to complete your submission.");
        // Reset input after successful upload
        e.target.value = "";
      } else {
        const errorMsg = response.data.message || "Failed to upload file";
        console.warn("⚠️ Upload failed:", errorMsg);
        toast.warning(errorMsg);
        setSelectedFile(null);
        setPreviewUrl(null);
        e.target.value = "";
      }
    } catch (error) {
      console.error("❌ Error uploading file:", error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "An error occurred during file upload";
      console.error("Error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      toast.error(errorMessage);
      setSelectedFile(null);
      setPreviewUrl(null);
      e.target.value = "";
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteFile = () => {
    setSelectedFile(null);
    setFileName([]);
    setPreviewUrl(null);
    setUploadStatus("");
    toast.success("File deleted successfully");
    document.getElementById("formFile").value = "";
  };

  const handleSaveNotification = async () => {
    if (!fileName.length) {
      setUploadStatus("Please select a file to upload.");
      return;
    }

    const postData = { udise_id, fileName };
    setIsSubmitting(true);
    try {
      const response = await axiosConn(
        "post",
        "save-eco-club-notification",
        postData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status === "success") {
        setShowModal(false);
        setNotificationStatus(true);
        toast.success("Notification submitted successfully");
      } else {
        toast.warning("Failed to upload file");
      }
    } catch (error) {
      console.log(error);
      setUploadStatus("An error occurred during upload.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Closing the modal (X / backdrop / Esc) should not lose an uploaded file.
  // If a file was uploaded but Submit wasn't clicked, persist it automatically.
  const handleCloseModal = () => {
    if (isUploading || isSubmitting) {
      return; // don't close mid upload/submit
    }
    if (fileName.length > 0) {
      handleSaveNotification(); // saves, then closes on success
      return;
    }
    setShowModal(false);
  };

  const data = {
    labels: [translate("Action"), translate("Awareness"), translate("Both")],
    datasets: [
      {
        data: [
          countData?.actionCount,
          countData?.awarenessCount,
          countData?.bothEventCount,
        ],
        backgroundColor: ["#28a745", "#ff9800", "#003366"],
      },
    ],
  };

  const updateLineChartData = (data) => {
    const labels = [
      translate("January"),
      translate("February"),
      translate("March"),
      translate("April"),
      translate("May"),
      translate("June"),
      translate("July"),
      translate("August"),
      translate("September"),
      translate("October"),
      translate("November"),
      translate("December"),
    ];
    const digitalData = data?.digitalCount || [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ];
    const physicalData = data?.physicalCount || [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ];

    if (digitalData.length !== labels.length) {
      console.warn(
        "Digital data length does not match labels length. Adjusting the data array."
      );
      while (digitalData.length < labels.length) digitalData.push(0);
      digitalData.length = labels.length;
    }

    if (physicalData.length !== labels.length) {
      console.warn(
        "Physical data length does not match labels length. Adjusting the data array."
      );
      while (physicalData.length < labels.length) physicalData.push(0);
      physicalData.length = labels.length;
    }

    setLineChartData({
      labels,
      datasets: [
        {
          label: translate("Digital"),
          data: digitalData,
          fill: false,
          borderColor: "rgba(75,192,192,1)",
        },
        {
          label: translate("Physical"),
          data: physicalData,
          fill: false,
          borderColor: "#742774",
        },
      ],
    });
  };

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  const handleOpenPledgePopup = () => {
    window.dispatchEvent(new Event("reopenPledgeModal"));
  };

  return (
    <>
      <section className="scholdashbrdSec">
        <div
          className="desktopView"
          style={{ marginTop: 70, textAlign: "end" }}
        >
          <Link className="button green bars" onClick={handleSidebar}>
            <FaBarsStaggered size={20} />
          </Link>
        </div>
        <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
          <SideBar langSelected={storeLang} index={0} role={role} />
        </div>
        {/* Mobile: tap the dimmed area beside the open drawer to close it.
            (On desktop there is no hamburger, so openSidebar stays false and
            this never renders.) */}
        {openSidebar && (
          <div
            className="sidebar-backdrop"
            onClick={handleSidebar}
            aria-hidden="true"
          />
        )}
        <div className="schlDashbrdRgt">
          <div className="row">
            <div className="col-md-12">
              <div className="card-user pageContainer sdh">
                {/* Identity row: school on the left, account-level links on the right */}
                <div className="sdh-top">
                  <div className="sdh-id">
                    <h5 className="sdh-name">{schoolName}</h5>
                    <p className="sdh-meta">
                      <span>{`${userData.district}, ${userData.state}`}</span>
                      <span className="sdh-dot" aria-hidden="true">•</span>
                      <span>{`UDISE ${udise_id}`}</span>
                    </p>
                    {role === 3 && (
                      <p className="sdh-meta">
                        {teacher_name ? `Welcome ${teacher_name} [Faculty]` : "[Faculty]"}
                      </p>
                    )}
                  </div>

                  <div className="sdh-tools">
                    {pledgeStatus?.success && pledgeStatus?.isPledgeTaken === false && (
                      <button type="button" className="sdh-chip sdh-chip--alert" onClick={handleOpenPledgePopup}>
                        <MdHealthAndSafety size={16} /> Fill Pledge Details
                      </button>
                    )}
                    {myPledge?.pledge && (
                      <button type="button" className="sdh-chip" onClick={() => setShowPledgeInfo(true)}>
                        <MdHealthAndSafety size={16} /> View Pledge Data
                      </button>
                    )}
                    {storeLang !== "en-IN" && (
                      <label className="sdh-lang">
                        <span>View in</span>
                        <select value={langSelected} onChange={(e) => setLangSelected(e.target.value)}>
                          <option value={storeLang}>
                            {Helper.languages.find((language) => language.langCode === storeLang)?.name}
                          </option>
                          <option value="en-IN">English</option>
                        </select>
                      </label>
                    )}
                  </div>
                </div>

                {/* Notification status — one compact line instead of a sentence + link */}
                {notificationStatus === true && (
                  <div className="sdh-status sdh-status--ok">
                    <span><FaCheckCircle /> <strong>Congratulations!</strong> {"You have successfully uploaded the notification."}</span>
                    <button type="button" className="sdh-link" onClick={() => setShowModal(true)}>
                      <MdEdit /> {"Re-upload notification"}
                    </button>
                  </div>
                )}
                {notificationStatus === false && (
                  <div className="sdh-status sdh-status--warn">
                    <span><FaExclamationCircle /> Please upload the Eco Clubs for Mission LiFE notification to proceed.</span>
                    <button type="button" className="sdh-link" onClick={() => setShowModal(true)}>
                      Upload now
                    </button>
                  </div>
                )}

                {/* Campaigns — each program's actions live together in one card */}
                <SchoolProgramCards
                  plantation3Trees={plantation3Trees}
                  swachhataSurvey={swachhataSurvey}
                  ewasteSummary={ewasteSummary}
                  sc6Summary={sc6Summary}
                  bricsSummary={bricsSummary}
                />
              </div>
            </div>
          </div>

          {/* RAS 2025–26 submission closure announcement (schools dashboard only) */}
          <div className="row">
            <div className="col-md-12">
              <div className="sdh-notice" role="note">
                <FaInfoCircle className="sdh-notice__icon" aria-hidden="true" />
                <p>
                  RAS 2025–26 data submission is closed. Thank you for your participation.
                  <strong> RAS 2026–27 coming soon!</strong>
                </p>
              </div>
            </div>
          </div>

          <Row className="bodybox">
            <Col lg="3" md="6" sm="6" className="boxOne _1">
              <Link to="/school/eventlist">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <Col md="3" xs="3">
                        <div className="icon-big text-center icon-warning">
                          <MdEventNote />
                        </div>
                      </Col>
                      <Col md="9" xs="9">
                        <div className="numbers">
                          <p className="card-category">
                            {translate("Overall_Events_Count")}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <CardTitle tag="h3" className="text-center">
                      {matrixCount?.number_events || 0}
                    </CardTitle>
                  </CardFooter>
                </Card>
              </Link>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _2">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <GrRestroomWomen />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("Number of Saplings Planted")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {/* While Ek Ped Maa Ke Naam 3.0 is enabled for schools: trees /
                        Miyawaki entered in Create-Event from 5 June 2026 onward (same
                        source as the 3.0 certificate). Otherwise the legacy sapling
                        figure from get-matrix-data. */}
                    {EKPED3_SCHOOL_ENABLED
                      ? Number(plantation3Trees) || 0
                      : Number(matrixCount?.saplings_planted) || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _3">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaBox />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("Amount of Harvest Produced")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.Amount_of_organic_produce || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _4">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <TbVaccineBottleOff />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("Amount of waste Collected")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.organic_waste_generated || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _5">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaHandHoldingWater />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("Number of Leaks Detected")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.leaks_detected || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <TbVaccineBottleOff />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("Amount of Plastic Waste Collected")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.single_use_plastic_bottle_collected || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _7">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <MdOutlineEnergySavingsLeaf />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate(
                            "Energy_Saved_(Total_Energy_Saved_Conserved_(in_Watts)"
                          )}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.electricity_units_consumed || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _8">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaBoxesPacking />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">
                          {translate("amount of e-waste collected")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                    {matrixCount?.Amount_of_ewaste_collected || 0}
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
          </Row>

        </div>
      </section>

      {showPledgeInfo && myPledge?.pledge && (
        <div className="pledge-modal-overlay">
          <div className="pledge-modal-container premium-eco-modal">
            <button className="modal-close-btn" onClick={() => setShowPledgeInfo(false)} aria-label="Close">
              <FaTimes />
            </button>

            <div className="modal-bg-watercolor top"></div>

            <div className="pledge-modal-header">
              <h1 className="eco-title">Pledge Details</h1>
              <p className="eco-subtitle">{myPledge.pledge.school_name}</p>
            </div>

            <div className="pledge-modal-body">
              <div className="pledge-details-content">
                <div className="details-grid">
                  <div className="detail-item">
                    <label>Pledge Taken?</label>
                    <div className={`status-badge ${myPledge.pledge.hasTakenPledge ? 'success' : 'danger'}`}>
                      {myPledge.pledge.hasTakenPledge ? "Yes" : "No"}
                    </div>
                  </div>
                  <div className="detail-item" style={{ textAlign: 'right' }}>
                    <label>Submission Date</label>
                    <div className="detail-value">
                      {new Date(myPledge.pledge.submittedAt || myPledge.pledge.createdAt || Date.now()).toLocaleDateString()}
                    </div>
                  </div>
                </div>

                <div className="stats-container">
                  <div className="stat-box">
                    <span className="stat-label">Teachers</span>
                    <span className="stat-number">{myPledge.pledge.teachersCount}</span>
                  </div>
                  <div className="stat-box">
                    <span className="stat-label">Students</span>
                    <span className="stat-number">{myPledge.pledge.studentsCount}</span>
                  </div>
                </div>

                <button
                  className="eco-submit-btn update-btn"
                  onClick={() => {
                    setShowPledgeInfo(false);
                    setShowUpdateModal(true);
                  }}
                >
                  <MdEdit size={20} /> Update Pledge Details
                </button>
              </div>
            </div>

            <div className="modal-footer-illustration">
              <div className="earth-hands-img"></div>
            </div>
          </div>
        </div>
      )}

      {showUpdateModal && (
        <PledgeModal
          isOpen={showUpdateModal}
          initialData={myPledge?.pledge}
          onClose={() => {
            setShowUpdateModal(false);
            refetchMyPledge();
            refetchPledgeStatus();
          }}
        />
      )}



      {/* Modal for Eco Club Notification Upload */}
      {/* enforceFocus/autoFocus off: on a first login this modal auto-opens under
          the Ek Ped 3.0 popup and its focus trap made the popup's fields untypable. */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        enforceFocus={false}
        autoFocus={false}
        className="eco-club-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Eco Clubs For Mission LiFE Notification</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="modal-message">Dear School,</p>
          <p className="modal-message">
            Please submit the filled Eco Clubs For Mission LiFE Notification
            here.
          </p>
          <Form className="mt-4">
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload Image or PDF <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                accept="image/jpeg,image/png,image/jpg,application/pdf"
                onChange={handleFileChange}
                className="h-auto"
              />
              {uploadStatus && (
                <Form.Text className="text-danger">{uploadStatus}</Form.Text>
              )}
            </Form.Group>
            {previewUrl && (
              <div className="preview-section mt-3">
                <div className="d-flex align-items-center">
                  {selectedFile?.type === "application/pdf" ? (
                    <embed
                      src={previewUrl}
                      type="application/pdf"
                      width="100"
                      height="100"
                      style={{ border: "1px solid #ccc" }}
                    />
                  ) : (
                    <img
                      src={previewUrl}
                      alt="Uploaded preview"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        border: "1px solid #ccc",
                      }}
                    />
                  )}
                  <div className="ms-3">
                    <p className="mb-0">{selectedFile?.name}</p>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={handleDeleteFile}
                      className="mt-2"
                    >
                      <FaTrash /> Delete
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {isUploading && (
              <div className="d-flex align-items-center mt-3 text-primary">
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                <span>Uploading notification...</span>
              </div>
            )}
          </Form>
          <div className="mb-3">
            <Button
              variant="outline-primary"
              onClick={() => window.open(previewUrl, "_blank")}
              disabled={!previewUrl}
            >
              Preview
            </Button>
          </div>
          <p className="modal-message" style={{ paddingTop: "2rem" }}>
            If you don’t have the required notification format, click the button
            below to download and submit it at the earliest.
          </p>
          <div className="download-section">
            <a
              href="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Eco%20Club%20formation_Noti.docx?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
              download="Eco_Club_Notification.docx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Download Word File
            </a>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {/* <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button> */}
          {isUploading ? (
            <Button variant="primary" disabled>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Uploading...
            </Button>
          ) : (
            fileName.length > 0 && (
              <Button
                variant="primary"
                onClick={() => handleSaveNotification()}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            )
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdminDashboard;